export const getContacts = (state) => state.contacts
export const getContactSuppliers = (state) => state.contactSuppliers
export const getScrollContacts= (state) => state.contactScroll
export const getScrollContactsMeta= (state) => state.contactScrollMeta
export const getScrollContactsCount = (state) => state.contactScrollCount
export const getContactStats = (state) => state.contactStats
